import { CardStyleInterpolators } from "@react-navigation/stack";
import { Colors, Spacings } from "react-native-ui-lib";
import {
  ModalCloseButton,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { RootDrawerToggle } from "@towersystems/roam-common-native";
import { SettingsRootParamList } from "../../../../types";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { DataSettingsScreen } from "../DataSettingsScreen";
import { EditBusinessAbnScreen } from "../EditBusinessAbnScreen";
import { EditBusinessWebsiteScreen } from "../EditBusinessWebsiteScreen";
import { EditCashManagedPaymentMethodScreen } from "../EditCashManagedPaymentMethodScreen";
import { EditLaybyDepositScreen } from "../EditLaybyDepositScreen";
import { EditMinLaybySpendScreen } from "../EditMinLaybySpendScreen";
import { EditShiftClosureFloatScreen } from "../EditShiftClosureFloat";
import { EditStockcountDestinationEmailScreen } from "../EditStockcountDestinationEmailScreen";
import { GeneralSettingsScreen } from "../GeneralSettingsScreen";
import { LaybySettingsRootScreen } from "../LaybySettingsRootScreen";
import { OfflineSalesListScreen } from "../OfflineSalesListScreen";
import { PosLayoutSettingsScreen } from "../PosLayoutSettingsScreen";
import { ResetTyroSimulationScreen } from "../ResetTyroSimulationScreen";
import { SaleInQueueOptionsScreen } from "../SaleInQueueOptionsScreen";
import { SelectCartPositionScreen } from "../SelectCartPositionScreen";
import { SelectLocationSettingScreen } from "../SelectLocationSettingScreen";
import { SettingsLandingScreen } from "../SettingsLandingScreen";
import { SetupTyroSettingScreen } from "../SetupTyroSettingsScreen";
import { ShiftSettingsRootScreen } from "../ShiftSettingsRootScreen";
import { StockManagementSettingsScreen } from "../StockManagementSettingsScreen";
import { TerminalSettingsRootScreen } from "../TerminalSettingsRootScreen";
import { TyroLogsScreen } from "../TyroLogsScreen";
import { TyroSettingsLandingScreen } from "../TyroSettingsLandingScreen";
import { EditEndOfShiftDestinationEmailScreen } from "../EditEndOfShiftDestinationEmailScreen";
import { LinklySettingsLandingScreen } from "../LinklySettingsLandingScreen";
import { LinklyPairPinpadScreen } from "../LinklyPairPinpadScreen";
import { LinklyPinpadSettingsListScreen } from "../LinklyPinpadSettingsListScreen";
import { LinklySettingsEditAutoPrintScreen } from "../LinklySettingsEditAutoPrintScreen";
import { ManagePaymentMethodsRootScreen } from "../ManagePaymentMethodsRootScreen";
import { EditBusinessPhoneScreen } from "../EditBusinessPhoneScreen/EditBusinessPhoneScreen";
import { DocketSettingsRootScreen } from "../DocketSettingsRootScreen";
import { ApiKeyVaultRootScreen } from "../ApiKeyVault";
import { SettingsManageUsersRootScreen } from "../SettingsManageUsers";
import { SelectAccountCountryTypeScreenScreen } from "../SelectAccountCountryTypeScreen";
import { SelectTimezoneScreen } from "../SelectTimezoneScreen";
import { ManageReceiptTemplatesRootScreen } from "../ReceiptTemplateScreens";
import { ManageLocationsRootScreen } from "../ManageLocationScreens";
import { ManageTerminalsRootScreen } from "../ManageTerminalScreens";
import { ManageAdminApiSecretsRootScreen } from "../ManageAdminApiSecretsScreen/ManageAdminApiSecretsRootScreen";
import { ManageSmartPayRootScreen } from "../ManageSmartPayScreens";
import { ManageTowerPaymentsRootScreen } from "../ManageTowerPaymentsScreen";
import { SetupNative2faRootScreen } from "../SetupNative2faRootScreen/SetupNative2faRootScreen";
import { UpdateCredentialsScreen } from "../UpdateCredentialsScreen";
import { ManageLlmStrategiesRootScreen } from "../ManageLlmStrategies";

const SettingDrawer = createStackHeaderNavigator<SettingsRootParamList>();

export const SettingsRootScreen = () => {
  // this is purely here to cause a re-render when the theme changes
  const theme = useThemeProvider();

  return (
    <SettingDrawer.Navigator
      screenOptions={{
        title: "",
        cardStyle: { height: "100%", backgroundColor: Colors.surface },
        headerLeftContainerStyle: { paddingLeft: Spacings.s5 },
        headerRightContainerStyle: { paddingRight: Spacings.s5 },
        headerTintColor: Colors.text,
        headerTitleAlign: "center",
        headerStyle: {
          backgroundColor: Colors.surface,
          borderBottomWidth: 1,
          borderBottomColor: Colors.borderColor,
        },
      }}
    >
      <SettingDrawer.Group
        screenOptions={{
          title: "",
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          headerLeft: () => <RootDrawerToggle />,
        }}
      >
        <SettingDrawer.Screen
          name="SettingsLandingScreen"
          component={SettingsLandingScreen}
        />
      </SettingDrawer.Group>

      <SettingDrawer.Group
        screenOptions={{
          headerLeft: () => <ModalCloseButton type="Back" />,
          animationEnabled: true,
          title: "",
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <SettingDrawer.Screen
          name="LaybySettingsRootScreen"
          component={LaybySettingsRootScreen}
        />
        <SettingDrawer.Screen
          name="SettingsManageUsersRootScreen"
          component={SettingsManageUsersRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="PosLayoutSettingsScreen"
          component={PosLayoutSettingsScreen}
        />
        <SettingDrawer.Screen
          name="GeneralSettingsScreen"
          component={GeneralSettingsScreen}
        />
        <SettingDrawer.Screen
          name="StockManagementSettingsScreen"
          component={StockManagementSettingsScreen}
        />
        <SettingDrawer.Screen
          name="DataSettingsScreen"
          component={DataSettingsScreen}
        />

        <SettingDrawer.Screen
          name="SetupTyroSettingScreen"
          component={SetupTyroSettingScreen}
        />
        <SettingDrawer.Screen
          name="TyroSettingsLandingScreen"
          component={TyroSettingsLandingScreen}
        />
        <SettingDrawer.Screen
          name="LinklySettingsLandingScreen"
          component={LinklySettingsLandingScreen}
        />
        <SettingDrawer.Screen
          name="LinklyPairPinpadScreen"
          component={LinklyPairPinpadScreen}
        />
        <SettingDrawer.Screen
          name="LinklyPinpadSettingsListScreen"
          component={LinklyPinpadSettingsListScreen}
        />
        <SettingDrawer.Screen
          name="LinklySettingsEditAutoPrintScreen"
          component={LinklySettingsEditAutoPrintScreen}
          options={{ title: "Receipt Auto Print" }}
        />
        <SettingDrawer.Screen
          name="TyroLogsScreen"
          component={TyroLogsScreen}
        />
        <SettingDrawer.Screen
          name="ResetTyroSimulationScreen"
          component={ResetTyroSimulationScreen}
        />
        <SettingDrawer.Screen
          name="OfflineSalesListScreen"
          component={OfflineSalesListScreen}
        />
        <SettingDrawer.Screen
          name="SelectLocationSettingScreen"
          component={SelectLocationSettingScreen}
        />

        <SettingDrawer.Screen
          name="TerminalSettingsRootScreen"
          component={TerminalSettingsRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="ManagePaymentMethodsRootScreen"
          component={ManagePaymentMethodsRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="SaleInQueueOptionsScreen"
          component={SaleInQueueOptionsScreen}
        />

        <SettingDrawer.Screen
          name="EditMinLaybySpendScreen"
          component={EditMinLaybySpendScreen}
        />
        <SettingDrawer.Screen
          name="EditLaybyDepositScreen"
          component={EditLaybyDepositScreen}
        />
        <SettingDrawer.Screen
          name="EditBusinessWebsiteScreen"
          component={EditBusinessWebsiteScreen}
        />
        <SettingDrawer.Screen
          name="EditBusinessPhoneScreen"
          component={EditBusinessPhoneScreen}
        />
        <SettingDrawer.Screen
          name="EditStockcountDestinationEmailScreen"
          component={EditStockcountDestinationEmailScreen}
        />
        <SettingDrawer.Screen
          name="EditBusinessAbnScreen"
          component={EditBusinessAbnScreen}
          options={{ title: "" }}
        />
        <SettingDrawer.Screen
          name="EditShiftClosureFloatScreen"
          component={EditShiftClosureFloatScreen}
        />
        <SettingDrawer.Screen
          name="ShiftSettingsRootScreen"
          component={ShiftSettingsRootScreen}
        />
        <SettingDrawer.Screen
          name="SelectAccountCountryTypeScreenScreen"
          component={SelectAccountCountryTypeScreenScreen}
        />
        <SettingDrawer.Screen
          name="SelectTimezoneScreen"
          component={SelectTimezoneScreen}
        />
        <SettingDrawer.Screen
          name="EditCashManagedPaymentMethodScreen"
          component={EditCashManagedPaymentMethodScreen}
        />
        <SettingDrawer.Screen
          name="SelectCartPositionScreen"
          options={{ title: "Select Cart Position" }}
          component={SelectCartPositionScreen}
        />
        <SettingDrawer.Screen
          name="EditEndOfShiftDestinationEmailScreen"
          component={EditEndOfShiftDestinationEmailScreen}
        />
        <SettingDrawer.Screen
          name="DocketSettingsRootScreen"
          component={DocketSettingsRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="ApiKeyVaultRootScreen"
          component={ApiKeyVaultRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="ManageReceiptTemplatesRootScreen"
          component={ManageReceiptTemplatesRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="ManageLocationsRootScreen"
          component={ManageLocationsRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="SetupNative2faRootScreen"
          component={SetupNative2faRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="UpdateCredentialsScreen"
          component={UpdateCredentialsScreen}
        />
        <SettingDrawer.Screen
          name="ManageTerminalsRootScreen"
          component={ManageTerminalsRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="ManageAdminApiSecretsRootScreen"
          component={ManageAdminApiSecretsRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="ManageSmartPayRootScreen"
          component={ManageSmartPayRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="ManageTowerPaymentsRootScreen"
          component={ManageTowerPaymentsRootScreen}
          options={{ headerShown: false }}
        />
        <SettingDrawer.Screen
          name="ManageLlmStrategiesRootScreen"
          component={ManageLlmStrategiesRootScreen}
          options={{ headerShown: false }}
        />
      </SettingDrawer.Group>
    </SettingDrawer.Navigator>
  );
};
